import {
    OrdersDetailPtaListElementType,
    OrdersDetailPtaType,
    OrdersDetailSubjectElementType,
    OrdersDetailSubjectType,
    OrdersDetailType,
    OrdersPreviousListElementSubjectElementType,
    OrdersPreviousListElementType,
    OrdersPreviousType,
    OrdersShipmentDeliveryConfirmTaxInfoType,
    OrdersShipmentDeliveryConfirmType,
    OrdersShipmentExchangeRateSearchParamReqType,
    OrdersShipmentExchangeRateSearchParamType
} from "../interface";

export const ordersDetailInit: OrdersDetailType = {
    _new_l_address_value: "",
    _new_l_order_type_m_value: "",
    _new_l_recipient_value: "",
    _new_l_vat_value: "",
    address1: "",
    address2: "",
    addressName: "",
    applicationName: "",
    currencyName: "",
    customerMemo: "",
    customerName: "",
    endDt: "",
    endFlag: "",
    endNo: "",
    endState: "",
    enduserName: "",
    industryName: "",
    newDAmount: 0,
    newDExchangeRate: 0,
    newDUnreceivableBond: 0,
    newDtEstimatedCollection: "",
    newDtOrder: "",
    newDtRequestShipment: "",
    newDtShipment: "",
    newLApplicationValue: "",
    newLCustomerValue: "",
    newLEnduserValue: "",
    newLIndustryValue: "",
    newLInvoiceAgentValue: "",
    newLShipToValue: "",
    newName: "",
    newPCurrency: 0,
    newPPayment: 0,
    newPProgress: 0,
    newPShipment: 0,
    newPShipmentName: "",
    newShipmentId: "",
    newTxtCollection: "",
    newTxtMemo: "",
    newTxtNote: "",
    newTxtProjectCode: "",
    orderNo: "",
    orderTypeName: "",
    owneridValue: "",
    owningUserName: "",
    paymentName: "",
    progressName: "",
    purchaseOrderId: 0,
    recipientMobilephone: "",
    recipientName: "",
    shipToName: "",
    shipmentNo: "",
    taxCharge: "",
    taxContact: "",
    taxEmail: "",
    taxFlag: "",
    chargeId: 0,
    chargeName: "",
    contactName: "",
    newLContactValue: "",
    salesInvoiceRemark: "",
    vatName: "",
    endType: "1",
    salesType: "1"
};

export const ordersDetailSubjectInit: OrdersDetailSubjectType = {
    list: [],
    newShipmentId: "",
    exchangeRateCondition1: null,
    exchangeRateCondition2: null,
    exchangeRateCondition3: null,
    exchangeRateUnit: null,
    wonUnit: null,
    newDExchangeRate: 0,
    newPCurrency: 0,
    exchangeDateMemo: "",
    startAt: "",
    endAt: "",
}

export const ordersDetailSubjectElementInit: OrdersDetailSubjectElementType = {
    _new_l_erp_product_value: "",
    _new_l_shipment_value: "",
    currencyName: "",
    newTxtNmItem: "",
    new_d_exchange_rate: 0,
    new_d_total: 0,
    new_d_unitprice: 0,
    new_d_won: 0,
    new_i_qty: 0,
    new_p_currency: "",
    new_shipment_subjectid: "",
    new_txt_standard: "",
    productGroupName: "",
    _new_l_product_group_value: "",
}

export const ordersDetailPtaInit: OrdersDetailPtaType = {
    claNumber: "",
    companyId: "",
    ptaList: []
}

export const ordersDetailPtaListElementInit: OrdersDetailPtaListElementType = {
    charge: "",
    claNumber: "",
    companyId: "",
    companyLegalName: "",
    erpAccountName: "",
    erpCode: "",
    outDateFlag: "",
    parentCompanyId: "",
    priceTier: "",
    pricingGroup: "",
    ptaTierId: 0,
    regAt: "",
    standard: "",
    vlookup: "",
}

export const ordersPreviousInit: OrdersPreviousType = {
    list: [],
    totalCount: 0
}

export const ordersPreviousListElementInit: OrdersPreviousListElementType = {
    newDtOrder: "",
    newShipmentId: "",
    orderNo: "",
    orderSubjectResList: []
}

export const ordersPreviousListElementSubjectElementInit: OrdersPreviousListElementSubjectElementType = {
    _new_l_erp_product_value: "",
    _new_l_shipment_value: "",
    currencyName: "",
    newTxtNmItem: "",
    new_d_exchange_rate: 0,
    new_d_total: 0,
    new_d_unitprice: 0,
    new_d_won: 0,
    new_i_qty: 0,
    new_p_currency: "",
    new_shipment_subject_id: "",
    new_txt_standard: "",
}

export const ordersShipmentDeliveryConfirmTaxInfoInit: OrdersShipmentDeliveryConfirmTaxInfoType = {
    issueDate: "",
    newShipmentId: "",
    newShipmentTaxId: 0,
    remark: "",
    taxFlag: "",
    taxNo: "",
}

export const ordersShipmentDeliveryConfirmInit: OrdersShipmentDeliveryConfirmType = {
    deliveryConfirmFile: null,
    endDt: "",
    endNo: "",
    invoiceNo: "",
    newShipmentId: "",
    salesInvoiceFile: null,
    shipmentRequestFile: null,
    taxInfo: ordersShipmentDeliveryConfirmTaxInfoInit
}

export const ordersShipmentExchangeRateSearchParamReqInit: OrdersShipmentExchangeRateSearchParamReqType = {
    endAt: "",
    keywordType: "",
    keywordType2: "",
    keywordType2Name: "",
    startAt: "",
}

export const ordersShipmentExchangeRateSearchParamInit: OrdersShipmentExchangeRateSearchParamType = {
    exchangeReq: ordersShipmentExchangeRateSearchParamReqInit,
    rateType: "",
    regionType: "",
    showType: "",
}